export class BuyPopUpConstants {
    public static readonly BUY_TEXT_ID: string = 'buyButtonBuyTXT';
    public static readonly PLAY_AT_TEXT_ID: string = 'buyPopUpPlayAtTXT';
    public static readonly TOTAL_BET_TEXT_ID: string = 'buyPopUpTotalBetTXT';
    public static readonly NOT_ENOUGH_RUBY_TEXT_ID: string = 'buyPopUpNotEnoughRubyTXT';
    public static readonly PLAY_TEXT_ID: string = 'buyButtonPlayTXT';
}